export default __webpack_public_path__ + "static/media/bishop.f67b2937.svg";